/**
 * .input-trim
 * Register a trigger for the .input-trim
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */


;(function($) {

    "use strict";

    $(function(){
        /**
         * Define the method
         * @return string
         */
        var trimValue = function(){
            return $(this).val($.trim($(this).val()));
        }

        /**
         * Append method to any input with class .input-trim
         */
        $('input.input-trim').blur(trimValue);

        /**
         * Append method to any input with class .input-trim... after the modal is loaded
         */
        $('#remote').on('loaded.bs.modal', function (e) {
            // Identify the Modal
            var modal  = $(this);
            // Attach the blur action
            modal.find('input.input-trim').blur(trimValue);
        });
    });

})(window.jQuery);
